import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IComplain } from 'shared/types/complaint';

const initialState: IComplain = {
  manifest: null,
  isError: false,
};

const complainSlice = createSlice({
  name: 'complain',
  initialState,
  reducers: {
    complainFailRequest: (state, action: PayloadAction<{ isError: boolean }>) => {
      state.isError = action.payload.isError;
    },
    complainDataFetched: (state, action: PayloadAction<{ manifest: IMicrofrontendManifest | null }>) => {
      state.manifest = action.payload.manifest;
    },
  },
  selectors: {
    selectComplain: state => state,
  },
});

export const {
  reducer: complainReducer,
  // eslint-disable-next-line no-empty-pattern
  actions: complainActions,
  selectors: { selectComplain },
} = complainSlice;
